import {match} from 'ts-pattern';

import {EntityResourceIds} from '@dms/api/shared';
import i18n from '@dms/i18n';

import {MessageContextResource} from '../types/MessageContextResource';

/**
 * @about Entity-type label for a message context link.
 *
 * The messages endpoint returns only `recordId` and `resourceId`, so the button names the kind of
 * record it opens rather than the record itself — resolving a display name would cost one request
 * per message.
 */
export const getMessageContextLinkLabel = (resource: MessageContextResource) =>
  match(resource)
    .with(EntityResourceIds.businessCase, () =>
      i18n.t('entity.customerMessage.labels.contextResource.BUSINESS_CASE')
    )
    .with(EntityResourceIds.customer, () =>
      i18n.t('entity.customerMessage.labels.contextResource.CUSTOMER')
    )
    .with(EntityResourceIds.interest, () =>
      i18n.t('entity.customerMessage.labels.contextResource.INTEREST')
    )
    .with(EntityResourceIds.rentalOrder, () =>
      i18n.t('entity.customerMessage.labels.contextResource.RENTAL_ORDER')
    )
    .with(EntityResourceIds.serviceCase, () =>
      i18n.t('entity.customerMessage.labels.contextResource.SERVICE_CASE')
    )
    .with(EntityResourceIds.serviceOrder, () =>
      i18n.t('entity.customerMessage.labels.contextResource.SERVICE_ORDER')
    )
    .with(EntityResourceIds.vehicle, () =>
      i18n.t('entity.customerMessage.labels.contextResource.VEHICLE')
    )
    .with(EntityResourceIds.workshopInterest, () =>
      i18n.t('entity.customerMessage.labels.contextResource.WORKSHOP_INTEREST')
    )
    .exhaustive();
